export interface DateObject {
    day: string
    month: string
    year: string
}
const dateFieldValue = (): DateObject => ({
    day: '',
    month: '',
    year: '',
});

export default dateFieldValue;
